import { WildNavigationType } from "../../../../../../data/enums/navigation_type";
import { FeaturesComponentListData } from "../../FeaturesData";

export const reportingListData: FeaturesComponentListData = {
  image: "https://firebasestorage.googleapis.com/v0/b/wild-live.appspot.com/o/v2%2Fimagesforbrochuresite%2Freporting%2Freports-seo.png?alt=media&token=01732a1d-a65f-4140-8963-3e689de66189",
  title: "Reporting",
  subtitle: "Analyse Your Performance",
  page: WildNavigationType.REPORTINGBROCHURE,
}